import { computed } from 'vue';
import type { NuxtLinkProps } from 'nuxt/app';

export type AllIrelandMenuItem = {
  label: string;
  to?: NuxtLinkProps['to'];
  shouldRender: boolean;
};

export const useAllIrelandNavigation = () => {
  const menuItems = computed<AllIrelandMenuItem[]>(() => [
    {
      label: 'Home',
      to: '/',
      shouldRender: true,
    },
    {
      label: 'About',
      to: '/about',
      shouldRender: true,
    },
    {
      label: 'Tournaments',
      to: '/tournaments',
      shouldRender: true,
    },
    {
      label: 'Memberships',
      to: '/memberships',
      // Temporarily hidden per Lexus feedback (May 2026) until membership plans
      // are populated. Re-enable once plans are live on /memberships.
      shouldRender: false,
    },
    {
      label: 'Gallery',
      to: '/gallery',
      shouldRender: true,
    },
    {
      label: 'Sponsorships',
      to: '/sponsorships',
      shouldRender: true,
    },
    {
      label: 'Contact',
      to: '/contact',
      shouldRender: true,
    },
  ]);

  const loginItem: AllIrelandMenuItem = {
    label: 'Login',
    to: '/login',
    shouldRender: true,
  };

  const visibleItems = computed(() => {
    return menuItems.value.filter((item) => item.shouldRender);
  });

  return {
    menuItems,
    visibleItems,
    loginItem,
  };
};
